"use strict"

export default {
  // List of user roles
  userRoles: ["guest", "user", "admin"],

  // Assets configuration
  assets: {
    // Base URL for static assets (can be overridden per environment)
    baseUrl: process.env.ASSETS_BASE_URL || "",
    // Whether to use S3 for assets (disabled by default in development)
    useS3: process.env.USE_S3_ASSETS === "true",
  },
}
